/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Metadata about the local hook adapter that translated a provider event into the Speakeasy hook contract.
 */
export type HookIngestSource = {
  /**
   * Stable adapter slug, e.g. claude, cursor, codex, or a customer hook name.
   */
  adapter: string;
  /**
   * Adapter implementation version.
   */
  adapterVersion?: string | undefined;
  /**
   * Hostname of the machine that emitted the hook event.
   */
  hostname?: string | undefined;
  /**
   * Provider-native event name, if one exists.
   */
  rawEventName?: string | undefined;
  /**
   * Self-reported email of the developer on the emitting machine (device agent or provider account), used for attribution when the API key is shared org-wide.
   */
  userEmail?: string | undefined;
};

/** @internal */
export type HookIngestSource$Outbound = {
  adapter: string;
  adapter_version?: string | undefined;
  hostname?: string | undefined;
  raw_event_name?: string | undefined;
  user_email?: string | undefined;
};

/** @internal */
export const HookIngestSource$outboundSchema: z.ZodMiniType<
  HookIngestSource$Outbound,
  HookIngestSource
> = z.pipe(
  z.object({
    adapter: z.string(),
    adapterVersion: z.optional(z.string()),
    hostname: z.optional(z.string()),
    rawEventName: z.optional(z.string()),
    userEmail: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      adapterVersion: "adapter_version",
      rawEventName: "raw_event_name",
      userEmail: "user_email",
    });
  }),
);

export function hookIngestSourceToJSON(
  hookIngestSource: HookIngestSource,
): string {
  return JSON.stringify(
    HookIngestSource$outboundSchema.parse(hookIngestSource),
  );
}
